/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
import { init, addBreadcrumb } from '@sentry/browser';
import type {
  Breadcrumb,
  BreadcrumbHint,
  EventHint,
  ErrorEvent,
} from '@sentry/types';
import type { Store } from 'easy-peasy';

import config from '../config';
import type { State } from '../reducers';

let store: Store<State> | undefined; // Updated on registering store.
const release = process.env.REACT_APP_RELEASE_ID || undefined;
const isProd = process.env.NODE_ENV === 'production';

if (isProd) {
  init({
    dsn: config.sentry.dsn,
    release,
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    beforeBreadcrumb: (breadcrumb: Breadcrumb, hint?: BreadcrumbHint) => {
      const { category, data } = breadcrumb;
      // Ignore very noisy successful fetches of OSF frames / poses
      if (category === 'fetch' || category === 'xhr') {
        if (
          data &&
          data.status_code === 200 &&
          data.url &&
          data.url.indexOf('drive-osf') > -1
        ) {
          return null;
        }
      }

      return breadcrumb;
    },
    beforeSend: (event: ErrorEvent, hint: EventHint): ErrorEvent | null => {
      if (store) {
        try {
          const state = store.getState();
          event.extra = event.extra || {};
          event.extra = {
            ...event.extra,
            'Redux State': state,
          };
          // TODO: Check if payload size would be too large.
          // TODO: Any custom state pruning can go here.
        } catch (err) {
          console.warn('Failed to serialize redux store.');
        }
      }

      // Batch together OSF request errors
      if (hint && hint.originalException instanceof Error) {
        const msg = hint.originalException.message;
        const isPngOsfFailure = msg.includes('png request failed');
        const isJsonOsfFailure = msg.includes('json request failed');
        if (isPngOsfFailure || isJsonOsfFailure) {
          event.fingerprint = ['OSF Frame Request Error'];
        }
      }

      return event;
    },
  });
}

export const sentryBreadcrumbMiddleware =
  () => (next: any) => (action: any) => {
    if (isProd) {
      addBreadcrumb({
        category: 'redux',
        message: action.type,
      });
    }
    return next(action);
  };

export const registerStore = (storeToRegister: Store<State>) => {
  store = storeToRegister;
};
